import { resourceSelectors } from '../../utils/resourceSelectors';

export const [
  periodicIndicesAllIds,
  periodicIndicesById,
  allPeriodicIndicesSelector,
] = resourceSelectors('periodicIndices');
